/**
 * @param minutes
 * @returns
 */
export function formatHour(minutes: number): string {
  if (minutes >= 60) {
    const hours = Math.floor(minutes / 60)
    const remainingMinutes = minutes % 60

    return `${hours}h ${remainingMinutes.toFixed(0)}min`
  } else {
    return `${minutes.toFixed(0)}min`
  }
}

/**
 * Format a date to a string in the format MMM DD, YYYY (e.g. Jan 01, 2021)
 * @param date
 * @returns {string}
 */
export function formatDate(date: Date): string {
  const formatter = new Intl.DateTimeFormat('en', {
    month: 'short',
    day: 'numeric',
    year: 'numeric',
  })

  return formatter.format(date)
}

/**
 * Convert a UTC date to a local date
 * @param date
 * @returns {Date}
 */
export function utcToLocalDate(date: Date): Date {
  const offset = new Date().getTimezoneOffset()

  return new Date(date.getTime() - offset * 60000)
}
